import { useState } from "react";
import { throwResponseError } from "../../../../utils/api-error-utils";
import { getAuthParams } from "../../../../utils/pacto-rebates-utils";

export function useLatePaymentPenaltyDelete() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    async function deleteLatePaymentPenalty(latePaymentPenaltyId) {
        if (!latePaymentPenaltyId) {
            const validationMessage = "Não foi possível identificar a penalidade por inadimplência.";

            setError(validationMessage);

            return {
                ok: false,
                reason: "validation",
                error: validationMessage
            };
        }

        try {
            setLoading(true);
            setError(null);

            const {
                accessToken,
                clientId
            } = getAuthParams();

            const requestOptions = {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    "access_token": accessToken,
                    "client_id": clientId
                }
            };

            const response = await fetch(
                process.env.REACT_APP_ESSILOR_API +
                    `pacto-rebates-admin/v1/penalidades-inadimplencia/${encodeURIComponent(latePaymentPenaltyId)}`,
                requestOptions
            );

            if (!response.ok) {
                await throwResponseError(
                    response,
                    "Não foi possível excluir a penalidade por inadimplência."
                );
            }

            return {
                ok: true
            };
        } catch (requestError) {
            setError(requestError.message);

            return {
                ok: false,
                reason: "request",
                error: requestError.message
            };
        } finally {
            setLoading(false);
        }
    }

    return {
        loading,
        error,
        deleteLatePaymentPenalty
    };
}